#!/usr/bin/env node

/**
 * @sibrik/editor — Local MCP server entry point.
 *
 * Runs as a stdio subprocess of Claude Desktop.
 * Provides video editing tools powered by Remotion.
 *
 * Claude Desktop config:
 * {
 *   "mcpServers": {
 *     "sibrik-editor": {
 *       "command": "npx",
 *       "args": ["-y", "@sibrik/editor"]
 *     }
 *   }
 * }
 */

import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import { createEditorServer } from './server.js';

async function main() {
  const server = createEditorServer();
  const transport = new StdioServerTransport();
  await server.connect(transport);

  console.error('[sibrik-editor] MCP server started (stdio transport)');
}

main().catch((err) => {
  console.error('[sibrik-editor] Fatal error:', err);
  process.exit(1);
});
